import REGEX from './regex.js';
function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}
export default validate;


// WEBPACK FOOTER //
// ./~/@snowplow/browser-tracker/~/uuid/dist/esm-browser/validate.js